import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  PARTNER_ID: {
    DOM: "",
    INTL: ""
  },
  SLOT_ID: {
    DOM: "",
    INTL: ""
  }
}

export const PublicGood = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const PUBLIC_GOOD = { ...template, ...VENDOR.PUBLIC_GOOD }  
  PREBID.VENDOR.PUBLIC_GOOD = PUBLIC_GOOD
  const { PARTNER_ID, SLOT_ID } = PUBLIC_GOOD
  const PARTNER_DOM = PARTNER_ID.DOM
  const PARTNER_INTL = PARTNER_ID.INTL
  const SLOT_DOM = SLOT_ID.DOM
  const SLOT_INTL = SLOT_ID.INTL
  const [expanded, setExpanded] = useState(expandAllVendors)
  const { STRING } = validation
  const { LENGTH } = STRING

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  const displayPartnerIdTable = () => {
    return (
    <Table size='small' aria-label='public-good-partner-id-table'>
      <TableHead>
        <TableRow>
          <TableCell style={{ width: '180px' }} />
          <TableCell style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
          <TableCell style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ width: '180px' }} ><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Partner IDs</Typography></TableCell>
          <TableCell style={{ textAlign: 'center' }}>
            <TextField
              margin='none'
              value={PARTNER_DOM}
              error={errors.PREBID_PUBLICGOOD_PIDD}
              helperText={errors.PREBID_PUBLICGOOD_PIDD && LENGTH.message}
              onChange={(event) => {
                const value = event.target.value
                PREBID.VENDOR.PUBLIC_GOOD.PARTNER_ID.DOM = value
                setErrors({ ...errors, PREBID_PUBLICGOOD_PIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                setOptions({ ...options, PREBID })
                setAllOptions({ ...allOptions, PREBID })
              }}
            />
          </TableCell>
          <TableCell style={{ textAlign: 'center' }}>
            <TextField
              margin='none'
              value={PARTNER_INTL}
              error={errors.PREBID_PUBLICGOOD_PIDI}
              helperText={errors.PREBID_PUBLICGOOD_PIDI && LENGTH.message}
              onChange={(event) => {
                const value = event.target.value
                PREBID.VENDOR.PUBLIC_GOOD.PARTNER_ID.INTL = value
                setErrors({ ...errors, PREBID_PUBLICGOOD_PIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                setOptions({ ...options, PREBID })
                setAllOptions({ ...allOptions, PREBID })
              }}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
    )
  }

  const displaySlotIdTable = () => {
    return (
    <Table size='small' aria-label='public-good-slot-id-table'>
      <TableBody>
        <TableRow>
          <TableCell style={{ width: '180px' }} ><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Slot IDs</Typography></TableCell>
          <TableCell style={{ textAlign: 'center' }}>
            <TextField
              margin='none'
              value={SLOT_DOM}
              error={errors.PREBID_PUBLICGOOD_SIDD}
              helperText={errors.PREBID_PUBLICGOOD_SIDD && LENGTH.message}
              onChange={(event) => {
                const value = event.target.value
                PREBID.VENDOR.PUBLIC_GOOD.SLOT_ID.DOM = value
                setErrors({ ...errors, PREBID_PUBLICGOOD_SIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                setOptions({ ...options, PREBID })
                setAllOptions({ ...allOptions, PREBID })
              }}
            />
          </TableCell>
          <TableCell style={{ textAlign: 'center' }}>
            <TextField
              margin='none'
              value={SLOT_INTL}
              error={errors.PREBID_PUBLICGOOD_SIDI}
              helperText={errors.PREBID_PUBLICGOOD_SIDI && LENGTH.message}
              onChange={(event) => {
                const value = event.target.value
                PREBID.VENDOR.PUBLIC_GOOD.SLOT_ID.INTL = value
                setErrors({ ...errors, PREBID_PUBLICGOOD_SIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                setOptions({ ...options, PREBID })
                setAllOptions({ ...allOptions, PREBID })
              }}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
    )
  }


  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='public-good-panel-content'
        id='public-good-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Public Good</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>{displayPartnerIdTable()}</Grid>
          <Grid item xs={12}>{displaySlotIdTable()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
